var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueEditor',_vm._g(_vm._b({staticClass:"flex column editor",attrs:{"value":_vm.value,"editor-toolbar":_vm.customToolbar,"editor-options":_vm.editorSettings},on:{"input":_vm.handleInput}},'VueEditor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }